(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('.disclosure__list-wrapper'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nuvia-accordions"] && !Shopify.designMode) return;
  try {
    
/* JS estático (opcional: abrir uno a la vez) */
(function(){
  var root = document.querySelector('[data-nuvia-acc]');
  if(!root) return;
  // Para “solo uno abierto a la vez”, descomentá:
  // var items = root.querySelectorAll('.nuvia-acc-item');
  // items.forEach(function(it){
  //   it.querySelector('.nuvia-acc-summary').addEventListener('click', function(){
  //     items.forEach(function(other){ if(other !== it) other.removeAttribute('open'); });
  //   });
  // });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nuvia-product-hero"] && !Shopify.designMode) return;
  try {
    
/* Delegación global + slide + lightbox */
(function(){
  function slideSwap(main, url){
  if (!main || !url) return;

  // Si ya está esa imagen, no hagas nada
  if (main.getAttribute('src') === url) return;

  // Marca "cargando" para estilos si querés (opcional)
  main.classList.add('is-loading');

  // Cambiá primero el src (el navegador empieza a traerla YA)
  main.setAttribute('src', url);
  main.setAttribute('srcset', url);

  // Pequeña animación de opacidad (crossfade)
  main.style.transition = 'opacity .18s ease';
  main.style.opacity = '0.001';

  // Cuando el navegador decodifique la imagen nueva, levantamos opacidad
  if (main.decode) {
    main.decode().catch(function(){ /* algunos navegadores viejos */ }).finally(function(){
      requestAnimationFrame(function(){
        main.style.opacity = '1';
        main.addEventListener('transitionend', function te(){
          main.style.transition = ''; // limpia
          main.classList.remove('is-loading');
          main.removeEventListener('transitionend', te);
        });
      });
    });
  } else {
    // Fallback si no existe decode()
    setTimeout(function(){
      main.style.opacity = '1';
      main.addEventListener('transitionend', function te(){
        main.style.transition = '';
        main.classList.remove('is-loading');
        main.removeEventListener('transitionend', te);
      });
    }, 50);
  }
}


  // click en miniaturas (funciona aunque Shopify recargue la sección)
  function onThumbTap(e){
    var btn = e.target.closest('.nuvia-thumb');
    if(!btn) return;
    var hero = btn.closest('[data-nuvia-hero]'); if(!hero) return;
    var main = hero.querySelector('.nuvia-main-img');
    var url  = btn.getAttribute('data-target');

    hero.querySelectorAll('.nuvia-thumb').forEach(function(t){
      t.classList.remove('is-active'); t.setAttribute('aria-selected','false');
    });
    btn.classList.add('is-active'); btn.setAttribute('aria-selected','true');

    slideSwap(main,url);
  }
  document.addEventListener('click', onThumbTap, {passive:true});

  // lightbox (zoom) al tocar la imagen principal
  function onMainClick(e){
    var img = e.target.closest('.nuvia-main-img'); if(!img) return;
    var src = img.getAttribute('src'); if(!src) return;

    var wrap = document.createElement('div');
    wrap.className = 'nuvia-zoom';
    wrap.innerHTML = '<img alt="" />';
    var zi = wrap.querySelector('img');
    zi.src = src; zi.srcset = src;

    function close(){ wrap.classList.remove('is-open'); setTimeout(function(){ wrap.remove(); },180); }
    wrap.addEventListener('click', close, {passive:true});
    document.addEventListener('keydown', function esc(ev){ if(ev.key==='Escape'){ close(); document.removeEventListener('keydown', esc); }});

    document.body.appendChild(wrap);
    requestAnimationFrame(function(){ wrap.classList.add('is-open'); });
  }
  document.addEventListener('click', onMainClick, {passive:true});
})();

  } catch(e) { console.error(e); }
})();
})();
